import React, { useState } from "react";
import { FaClock, FaEye, FaEyeSlash } from "react-icons/fa";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";


import { MdClose } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import register from "../auth/registerApi";
import login from "../auth/loginApi"
import getUser from "../auth/userGetApi";
import LogoCollage from "../pages/LogoCollage.jpeg"

const AdmissionPortalLayout = () => {
  const [studentData, setStudentData] = useState({
    aadharNumber: "",
    dateOfBirth: "",
  });

  const [studentRegister, setStudentRegister] = useState({
    name: "",
    email: "",
    phone: "",
    userid: "",
    dob: "",
  });




  const [show, setShow] = useState(false);
  const [showRegisterPassword, setShowRegisterPassword] = useState(false);
  const [loginModal, setLoginModal] = useState(false);

  const { isLoggedIn, loginModale, registerModale, userData } = useSelector(
    (state) => state.auth,
  );

  const dispatch = useDispatch();


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setStudentData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleRegisterInputChange = (e) => {
    const { name, value } = e.target;
    setStudentRegister((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [aadharerror, setaadharerror] = useState("");
  const [doberror, setdoberror] = useState("");
  const [registerErrors, setRegisterErrors] = useState({});
  
  const getTokken = localStorage.getItem("tokken");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [registerLoading, setRegisterLoading] = useState(false);
    
 const location = useLocation();

  const currentPath = location.pathname;


  const handleSubmit = async () => {
    if (studentData.aadharNumber.length !== 12) {
      alert("Please enter valid aadhar number");
      return;
    }

    if (studentData.dateOfBirth.length !== 8) {
      alert("Please enter valid password (DDMMYYYY)");
      return;
    }

    const formData = new FormData();
    formData.append("userid", studentData.aadharNumber);
    formData.append("password", studentData.dateOfBirth);
    formData.append("role", "3");
    setLoading(true);

    try {
      const respo = await login(formData);


      console.log(respo)
     
      
      if (respo.access_token) {
        localStorage.setItem("tokken", respo.access_token);
        const res = await getUser(respo.access_token )

        console.log(res)

  
        localStorage.setItem("userData", JSON.stringify(res));
        setaadharerror("");
        setdoberror("");
        dispatch({ type: "LOGINMODALE", payload: false });
        window.location.reload();
      } else {
        alert(respo.message || "Login failed. Please try again.");
      }
    } catch (error) {
      alert("Login failed. Please check your credentials.");
      console.error("Login error:", error);
    } finally {
      setLoading(false);
    }
  };

  
  const handleRegisterSubmit = async () => {

    console.log("aya kya data")


    
    const errors = {};
    
    if (!studentRegister.name.trim()) {
      errors.name = "Name is required";
    }
    
      console.log("aya kya data")
    if (!studentRegister.email.trim()) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(studentRegister.email)) {
      errors.email = "Email is invalid";
    }
  
      console.log("aya kya data")
    if (!studentRegister.phone) {
      errors.phone = "Phone number is required";
    } else if (studentRegister.phone.length !== 10) {
      errors.phone = "Phone number must be 10 digits";
    }
      console.log("aya kya data")
    if (!studentRegister.userid) {
      errors.userid = "Aadhaar number is required";
    } else if (studentRegister.userid.length !== 12) {
      errors.userid = "Aadhaar number must be 12 digits";
    }
      console.log("aya kya data")
    if (!studentRegister.dob) {
      errors.dob = "dob is required";
    } else if (studentRegister.dob.length !== 8) {
      errors.dob = "dob must be 8 digits (DDMMYYYY)";
    }

      console.log("aya kya data")  

  console.log("aya kya data")  
    setRegisterErrors({});
    setRegisterLoading(true);

    console.log(studentRegister)


    const formData = new FormData();
    formData.append("name", studentRegister.name);
    formData.append("email", studentRegister.email);
    formData.append("dob", studentRegister.dob );
     formData.append("dob_confirmation ", studentRegister.dob );
    formData.append("phone", studentRegister.phone);
    formData.append("userid", studentRegister.userid);
    formData.append("role", "3");

    try {
      const response = await register(formData);
      
      if (response.success) {
        alert("Registration successful! Please login.");
    
        setStudentRegister({
          name: "",
          email: "",
          dob: "",
          phone: "",
          userid: "",
          password: "",
        });
        
        dispatch({ type: "REGISTERMODALE", payload: false });
        dispatch({ type: "LOGINMODALE", payload: true });
      } else {
       setRegisterErrors(response.errors)
      }
    } catch (error) {
    console.log(error)
    } finally {
      setRegisterLoading(false);
    }
  };

  const logout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      localStorage.removeItem("tokken");
      localStorage.removeItem("userData");
      window.location.reload();
      navigate("/", { replace: true });
    }
  };


  const currentPath2 = window.location.pathname

  return (
    <div>
      <div>
        <div className="admission-portal-navbar">
          <div>
            <div>
              <img
                src={
                  LogoCollage
                }
                alt="College Logo"
              />
              <div>
                <h1>Government Degree College Milak Rampur (U.P.)</h1>
                <p>ADMISSION-2026-27</p>
              </div>
            </div>

            <div>
              {isLoggedIn ? (
                <>
                  <div className="user-profile-container">
                    <div className="user-info">
                      <p className="user-name">{userData?.applicant_name}</p>
                     <p className="user-urn">{userData?.admissions[0]?.applicant_name 
    ? userData?.admissions[0]?.applicant_name 
    : userData?.name}
</p>
                    </div>
                    <button className="logout-btn" onClick={logout}>
                      Logout
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <button
                    onClick={() =>
                      dispatch({ type: "LOGINMODALE", payload: true })
                    }
                  >
                    Login
                  </button>
                  <button
                    onClick={() =>
                      dispatch({ type: "REGISTERMODALE", payload: true })
                    }
                  >
                    Register
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="home-page">
       {isLoggedIn && (
  <div className="side-bar-portal">
    <div className="sidebar-menu">
         <Link to={"/"} className={` sidebar-item ${ currentPath2 === "/" && "active"}`}>
    
        <span className="sidebar-text">Home</span>
      </Link>

  

      {
        userData?.admissions.length > 0 && (
 <Link to={`/id-card/${userData?.name}`} className={` sidebar-item ${ currentPath.includes("/id-card") && "active"}`}>
    
        <span className="sidebar-text">ID Card</span>
      </Link>
        )
      }
     
       <Link to={"/admission-form"} className={` sidebar-item ${ currentPath.includes("/admission-form") && "active"}`}>
        
        <span className="sidebar-text">Admission Form</span>
      </Link>
    </div>
  </div>
)}
        <div className="content-section">
          <Outlet />
        </div>
      </div>

     
      {loginModale && (
        <div className="admission-login-page">
          <div>
            <div>
              <h2 className="login-header">Login</h2>
              <MdClose
                className="MdClose"
                onClick={() =>
                  dispatch({ type: "LOGINMODALE", payload: false })
                }
              />
            </div>

            <div className="login-form">
              <label htmlFor="aadhaar" className="form-label">
                Enter Your Aadhaar Number
              </label>
              <input
                onChange={(e) => {
                  if (/^\d{0,12}$/.test(e.target.value)) {
                    handleInputChange(e);
                  }
                }}
                value={studentData.aadharNumber}
                name="aadharNumber"
                type="text"
                id="aadhaar"
                placeholder="12-digit Aadhaar number"
                required
              />
              {aadharerror && <p className="aadhar-error">{aadharerror}</p>}

              <label htmlFor="dob" className="form-label">
                Enter Your Date of Birth (Password)
                <p className="Hint">
                  अपनी जन्मतिथि (DD/MM/YYYY) बिना स्लैश के डालें – DDMMYYYY
                </p>
              </label>
              <div className="form-group-1">
                <input
                  onChange={(e) => {
                    if (/^\d{0,8}$/.test(e.target.value)) {
                      handleInputChange(e);
                    }
                  }}
                  value={studentData.dateOfBirth}
                  name="dateOfBirth"
                  type={show ? "text" : "password"}
                  id="dob"
                  placeholder="DDMMYYYY"
                  className=""
                  required
                />

                <button
                  className="show-ps-button"
                  type="button"
                  onClick={() => setShow(!show)}
                >
                  {show ? <FaEye /> : <FaEyeSlash />}
                </button>
              </div>

              {doberror && <p className="aadhar-error">{doberror}</p>}

              <button
                type="submit"
                onClick={handleSubmit}
                className="submit-btn"
                disabled={loading}
              >
                {loading ? "Loading..." : "Login"}
              </button>
              <div className="register-login-button">
                <p>or</p>
                <h5
                  onClick={() => {
                    dispatch({ type: "LOGINMODALE", payload: false });
                    dispatch({ type: "REGISTERMODALE", payload: true });
                  }}
                >
                  Register user
                </h5>
              </div>
            </div>
          </div>
        </div>
      )}

    
      {registerModale && (
        <div className="admission-login-page">
          <div>
            <div>
              <h2 
              onClick={()=>console.log(registerErrors)}
              className="login-header">Register</h2>
              <MdClose
                className="MdClose"
                onClick={() =>{
                   dispatch({ type: "REGISTERMODALE", payload: false })

                  setRegisterErrors({})
                }
                 
                }
              />
            </div>

            <div className="login-form">
             
              <label htmlFor="name" className="form-label">
                Full Name
              </label>
              <input
                onChange={handleRegisterInputChange}
                value={studentRegister.name}
                name="name"
                type="text"
                id="name"
                placeholder="Enter your full name"
                required
              />
              {registerErrors.name && (
                <p className="aadhar-error">{registerErrors.name}</p>
              )}

              {/* Email */}
              <label htmlFor="email" className="form-label">
                Email Address
              </label>
              <input
                onChange={handleRegisterInputChange}
                value={studentRegister.email}
                name="email"
                type="email"
                id="email"
                placeholder="Enter your email"
                required
              />
              {registerErrors?.email && (
                <p className="aadhar-error">{registerErrors?.email[0]}</p>
              )}

             

              {/* Phone */}
              <label htmlFor="phone" className="form-label">
                Phone Number
              </label>
              <input
                onChange={(e) => {
                  if (/^\d{0,10}$/.test(e.target.value)) {
                    handleRegisterInputChange(e);
                  }
                }}
                value={studentRegister.phone}
                name="phone"
                type="text"
                id="phone"
                placeholder="10-digit phone number"
                required
              />
              {registerErrors.phone && (
                <p className="aadhar-error">{registerErrors.phone}</p>
              )}

              {/* Aadhaar Number */}
              <label htmlFor="registerAadhaar" className="form-label">
                Aadhaar Number (User ID)
              </label>
              <input
                onChange={(e) => {
                  if (/^\d{0,12}$/.test(e.target.value)) {
                    handleRegisterInputChange(e);
                  }
                }}
                value={studentRegister.userid}
                name="userid"
                type="text"
                id="registerAadhaar"
                placeholder="12-digit Aadhaar number"
                required
              />
              {registerErrors.userid && (
                <p className="aadhar-error">{registerErrors.userid}</p>
              )}

              {/* Password */}
              <label htmlFor="registerPassword" className="form-label">
                Password (Date of Birth - DDMMYYYY)
                <p className="Hint">
                  अपनी जन्मतिथि (DD/MM/YYYY) बिना स्लैश के डालें – DDMMYYYY
                </p>
              </label>
              <div className="form-group-1">
                <input
                  onChange={(e) => {
                    if (/^\d{0,8}$/.test(e.target.value)) {
                      handleRegisterInputChange(e);
                    }
                  }}
                  value={studentRegister.dob}
                  name="dob"
                  type={showRegisterPassword ? "text" : "dob"}
                  id="registerPassword"
                  placeholder="DDMMYYYY"
                  required
                />

                <button
                  className="show-ps-button"
                  type="button"
                  onClick={() => setShowRegisterPassword(!showRegisterPassword)}
                >
                  {showRegisterPassword ? <FaEye /> : <FaEyeSlash />}
                </button>
              </div>
              {registerErrors.password && (
                <p className="aadhar-error">{registerErrors.password}</p>
              )}

              <button
                type="submit"
                onClick={handleRegisterSubmit}
                className="submit-btn"
                disabled={registerLoading}
              >
                {registerLoading ? "Registering..." : "Register"}
              </button>
              
              <div className="register-login-button">
                <p>Already have an account?</p>
                <h5
                  onClick={() => {
                    dispatch({ type: "REGISTERMODALE", payload: false });
                    dispatch({ type: "LOGINMODALE", payload: true });
                  }}
                >
                  Login here
                </h5>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdmissionPortalLayout;